import {createContext, Dispatch, SetStateAction, useMemo, useState} from 'react'

export interface IPortalDashboardContext {
    stateCounter: number;
    setStateCounter: Dispatch<SetStateAction<number>>;
    errorMessage: string | undefined;
    setErrorMessage: Dispatch<SetStateAction<string | undefined>>;
}

export const PortalDashboardContext = createContext<IPortalDashboardContext | undefined>(undefined);

interface PortalDashboardContextProviderProps {
    children: React.ReactNode;
}

export function PortalDashboardContextProvider({children}: Readonly<PortalDashboardContextProviderProps>)
{
    const [stateCounter, setStateCounter] = useState<number>(0);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const exposedData = useMemo<IPortalDashboardContext>(() => ({
        stateCounter,
        setStateCounter,
        errorMessage,
        setErrorMessage,
    }), [stateCounter, errorMessage]);

    return (
        <PortalDashboardContext.Provider value={exposedData}>
            {children}
        </PortalDashboardContext.Provider>
    );
}
